import React, { createContext, useContext, useState } from "react";

const BreadcrumbsContext = createContext();

export const BreadcrumbsProvider = ({ children }) => {
  const [showBreadcrumbs, setShowBreadcrumbs] = useState(false);

  return (
    <BreadcrumbsContext.Provider value={{ showBreadcrumbs, setShowBreadcrumbs }}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};

export const useBreadcrumbs = () => useContext(BreadcrumbsContext);
